import React, { Component } from 'react';
import { View, Button, Modal, Spinner } from '../UIElements/All.js';
import { Colors, ButtonColors, ModalColors } from '../Managers/ThemeManager';
import Loc from '../UIElements/Localization.js';
import { getRewards, spendCredit } from '../Managers/NetworkManager';
import { pop, triggerAction } from '../Managers/AppActions';
import { addPayment, close, setPageTitles } from '../Managers/LSLoyaltyAPI';
var LocalizationManager = require('../Managers/LocalizationManager.js');

export default class AddPayment extends Component 
{
  constructor(props) 
  {
    super(props);
    var state = this.props.location.state;
    state.isUpdating = false;
  	var outstandingAmount = state.outstandingAmount;
  	var userCredit = parseFloat(state.user.Credit);
  	var newAmount = Math.min(userCredit, outstandingAmount);
    state.currentAmount = newAmount.toFixed(2);
    state.isInError = false;
    state.isFull = true;
    this.state = state;
  }

  componentDidMount()
  {
	LocalizationManager.localizedStringForKey("PAY_WITH_APP_PAGE_TITLE", [], (retrievedString)=>
	{
		setPageTitles("asf",retrievedString, "asdf");
	});  	
  }

  clearSelected()
  {
  	this.setAmount(0);
  }

  numSelected(num)
  {
  	var currentAmount = this.state.currentAmount;
  	if( this.state.isFull ) currentAmount = this.setAmount(0);
  	var newAmount = currentAmount;
  	newAmount = newAmount*10;
  	newAmount += .01*num;
  	this.setAmount(newAmount);
  }

  fullSelected()
  {
  	var outstandingAmount = this.state.outstandingAmount;
  	var userCredit = parseFloat(this.state.user.Credit);
  	var newAmount = Math.min(userCredit, outstandingAmount);
  	this.setAmount(newAmount);
  }

  setAmount(newAmount)
  {
  	var isInError = (newAmount > this.state.user.Credit) || (newAmount > this.state.outstandingAmount);
  	var currentAmount = newAmount.toFixed(2);
  	var isFull = currentAmount == parseFloat(this.state.outstandingAmount).toFixed(2);
  	this.setState({isInError, currentAmount, isFull})

  	return currentAmount;
  }

  cancelSelected()
  {
  	pop(this)
  }

  okSelected()
  {
  	var self = this;
  	if( this.state.isInError )
  	{
		if( this.state.currentAmount > this.state.user.Credit ) 
		{
			self._modal.showAlert("ERROR_ALERT_TITLE", "INPUT_NOT_MORE_CREDIT_ALERT_BODY", ["OKAY_BUTTON"], [()=>{self._modal.hide()}]);
		}
		else if( this.state.currentAmount > this.state.outstandingAmount ) 
		{
			self._modal.showAlert("ERROR_ALERT_TITLE", "INPUT_NOT_MORE_BALANCE_ALERT_BODY", ["OKAY_BUTTON"], [()=>{self._modal.hide()}]);
		}
  		
  		return;
	}
	this._modal.showSpinner("EXECUTING_TRANSACTION_TITLE");
	
  	var fullName = this.state.user.Name;
  	spendCredit(this.state.user.UserID, this.state.user.Hash, this.state.currentAmount).then((response)=>
  	{
  		addPayment(fullName, self.state.currentAmount+"", response.TransactionID, this.state.user.UserID, this.state.user.Hash, this.state.accountType).then(()=>
		{
			self._modal.hide();
			close();
		});
  	})
  }

  render() 
  {
  	var self = this;

    return (
      <View style={{backgroundColor:Colors.background1, flex:1, alignSelf:'stretch', justifyContent:'center', alignItems:'center', flexDirection:'row', padding:60}}>
      	<View style={{flex:1}} />
      	<View style={{flex:-1, width:468, height:600, position:'relative', flexDirection:'column', justifyContent:'center'}}>
	      	
	      	<View style={{flex:1, alignItems:'stretch', overflow:'hidden', alignSelf:'stretch', flexDirection:'column', justifyContent:'center'}}>
	      		<View style={{position:'relative', alignSelf:'stretch', flex:-1, height:100, backgroundColor:Colors.background3, borderRadius:4, margin:12}}>
		      		<View style={{flex:1, alignSelf:'center', color:Colors.text1, justifyContent:'space-around', alignItems:'center', flexDirection:'column', fontSize:18, padding:20}}>
		      			<View style={{flex:-1, flexDirection:'column'}}>
			      			<View style={{flex:-1, margin:4}}>
			      				<View style={{flex:1, marginRight:4, color:Colors.label1}}>
								  <Loc locKey="OUTSTANDING_LABEL"></Loc>
			      				</View>
			      				<View style={{flex:1}}>
			      					{this.state.outstandingAmount}
			      				</View>
	      					</View>
		      			</View>
		      			<View style={{flex:-1, alignSelf:'stretch', flexDirection:'row'}}>
		      				<View style={{flex:1}} />
			      			<View style={{flex:-1, margin:4}}>
			      				<View style={{flex:-1, marginRight:4, color:Colors.label1}}>
								  <Loc locKey="CUSTOMER_CREDIT_LABEL"></Loc>									  
			      				</View>
			      				<View style={{flex:-1}}>
			      					{this.state.user.Credit}
			      				</View>
	      					</View>
	      					<View style={{flex:1}} />
		      			</View>
      				</View>
		      	</View>

		      	<Button onPress={()=>{}} type={3} colors={ButtonColors} style={{flex:-1, height:80, margin:12, borderRadius:4, flexDirection:'row', alignItems:'Center', textAlign:'right', justifyContent:'center', backgroundColor:this.state.isInError ? Colors.input1ErrorBackground : Colors.input1Background, color:Colors.input1Text, fontSize:32, padding:12}}>
		      		<View style={{flex:1}} />
	      			{this.state.currentAmount}
		      	</Button>

		      	<View style={{flex:1, margin:12, flexDirection:'column', justifyContent:'center', alignItems:'stretch'}}>
		      		<View style={{flex:1, flexDirection:'row', alignItems:'stretch'}}>
		      			<Button onPress={()=>this.numSelected(7)} type={3} colors={ButtonColors} style={{flex:1, height:-1, alignSelf:'stretch', margin:2}}>
				      	{"7"}
				      	</Button>
				      	<Button onPress={()=>this.numSelected(8)} type={3} colors={ButtonColors} style={{flex:1, height:-1, alignSelf:'stretch', margin:2}}>
				      	{"8"}
				      	</Button>
				      	<Button onPress={()=>this.numSelected(9)} type={3} colors={ButtonColors} style={{flex:1, height:-1, alignSelf:'stretch', margin:2}}>
				      	{"9"}
				      	</Button>
		      		</View>
		      		<View style={{flex:1, flexDirection:'row', alignItems:'stretch'}}>
		      			<Button onPress={()=>this.numSelected(4)} type={3} colors={ButtonColors} style={{flex:1, height:-1, alignSelf:'stretch', margin:2}}>
				      	{"4"}
				      	</Button>
				      	<Button onPress={()=>this.numSelected(5)} type={3} colors={ButtonColors} style={{flex:1, height:-1, alignSelf:'stretch', margin:2}}>
				      	{"5"}
				      	</Button>
				      	<Button onPress={()=>this.numSelected(6)} type={3} colors={ButtonColors} style={{flex:1, height:-1, alignSelf:'stretch', margin:2}}>
				      	{"6"}
				      	</Button>
		      		</View>
		      		<View style={{flex:1, flexDirection:'row', alignItems:'stretch'}}>
		      			<Button onPress={()=>this.numSelected(1)} type={3} colors={ButtonColors} style={{flex:1, height:-1, alignSelf:'stretch', margin:2}}>
				      	{"1"}
				      	</Button>
				      	<Button onPress={()=>this.numSelected(2)} type={3} colors={ButtonColors} style={{flex:1, height:-1, alignSelf:'stretch', margin:2}}>
				      	{"2"}
				      	</Button>
				      	<Button onPress={()=>this.numSelected(3)} type={3} colors={ButtonColors} style={{flex:1, height:-1, alignSelf:'stretch', margin:2}}>
				      	{"3"}
				      	</Button>
		      		</View>
		      		<View style={{flex:1, flexDirection:'row', alignItems:'stretch'}}>
		      			<Button onPress={()=>this.cancelSelected()} type={1} colors={ButtonColors} style={{flex:1, height:-1, alignSelf:'stretch', margin:2}}>
						<Loc locKey="CANCEL_BUTTON"></Loc>
				      	</Button>
				      	<Button onPress={()=>this.numSelected(0)} type={3} colors={ButtonColors} style={{flex:1, height:-1, alignSelf:'stretch', margin:2}}>
				      	{"0"}
				      	</Button>
				      	<Button onPress={()=>this.clearSelected()} type={1} colors={ButtonColors} style={{flex:1, height:-1, alignSelf:'stretch', margin:2}}>
						<Loc locKey="CLEAR_BUTTON"></Loc>
				      	</Button>
		      		</View>
		      	</View>
		      	<Button onPress={()=>this.okSelected()} enabled={!this.state.isInError} type={2} colors={ButtonColors} style={{alignSelf:'stretch', margin:12}}>
		      	{"Pay"}
		      	</Button>
	      	</View>
	      	{
	      		this.state.isUpdating ?
	      			<View style={{position:'absolute', top:0, left:0, bottom:0, right:0, alignSelf:'stretch', color:Colors.text1, justifyContent:'center', alignItems:'center', backgroundColor:Colors.background2LoadingBackground}}>
	      				<Spinner color={ModalColors.border} />
	      			</View>
	      		: null
	      	}
      	</View>
      	<View style={{flex:1}} />
      	<Modal ref={(a) => { this._modal = a; }} colors={ModalColors} />
      </View>
    );
  }
}
